export const routes = {
  homepage: '/',
  catalog: '/catalog',
  // Shares the /catalog/:param segment with brandCatalog below. Brand slugs are
  // canonicalised to a "-spare-parts" suffix, so CatalogPage tells the two apart
  // by that suffix and by looking the slug up in the catalog roots.
  categoryCatalog: '/catalog/:categorySlug',
  brandCatalog: '/catalog/:brand',
  // Category paths of any depth (/catalog/braking-system/brake-caliper). Three
  // segments also match vehicleCatalog below, so CatalogPage tells them apart by
  // the first segment - brand slugs always carry the "-spare-parts" suffix.
  deepCategoryCatalog: '/catalog/*',
  vehicleCatalog: '/catalog/:brand/:vehicleModel/:vehicle',
  products: '/products',
  categoryProducts: '/products/:categorySlug',
  parentCategoryProducts: '/products/:parentCategorySlug/:categorySlug',
  // Deeper listings spell out every ancestor
  // (/products/body/hatchesbonnets.../doorsparts-1). React Router ranks the
  // patterns above higher for one and two segments, so this catches 3+.
  deepCategoryProducts: '/products/*',
  product: '/product/:name/:skuWithName',
  productOemCode: '/product/:oem',
  cart: '/cart',
  checkout: '/checkout',
  checkoutOrder: '/checkout/order',
  // Where Stripe / PayPal send the buyer back to. It only forwards: a paid
  // order on to orderSuccess, anything else back to the basket.
  checkoutRedirect: '/checkout/success',
  // The thank-you page - the conversion URL marketing counts, so it opens
  // once per paid order and never for a cancel, a refresh or a typed-in URL.
  orderSuccess: '/order-success',
  returns: '/returns',
  orderStatus: '/order-status',
  profile: {
    address: '/profile/address',
    bankDetails: '/profile/bank-details',
    favorites: '/profile/favorites',
    orders: '/profile/orders',
    settings: '/profile/settings',
    vehicles: '/profile/vehicles',
  },
  articles: {
    index: '/articles',
    categories: '/articles/categories',
    category: '/articles/categories/:slug',
    article: '/articles/:slug',
  },
  auth: {
    passwordReset: '/',
  },
  staticPage: '/:slug',
};
